module.exports = __webpack_public_path__ + "static/media/icon_115.4e88c882.svg";